/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BigNumberish } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { MetaFaucet } from "../MetaFaucet";

export class MetaFaucet__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _tokenFaucets: string[],
    _mintAmounts: BigNumberish[],
    overrides?: Overrides
  ): Promise<MetaFaucet> {
    return super.deploy(
      _tokenFaucets,
      _mintAmounts,
      overrides || {}
    ) as Promise<MetaFaucet>;
  }
  getDeployTransaction(
    _tokenFaucets: string[],
    _mintAmounts: BigNumberish[],
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _tokenFaucets,
      _mintAmounts,
      overrides || {}
    );
  }
  attach(address: string): MetaFaucet {
    return super.attach(address) as MetaFaucet;
  }
  connect(signer: Signer): MetaFaucet__factory {
    return super.connect(signer) as MetaFaucet__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MetaFaucet {
    return new Contract(address, _abi, signerOrProvider) as MetaFaucet;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokenFaucets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_mintAmounts",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Mint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "getTokens",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initializeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dst",
        type: "address",
      },
    ],
    name: "mintAllAsOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "mintAmounts",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "dst",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amt",
        type: "uint256",
      },
    ],
    name: "mintAsOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "restoreAllFaucetsOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "restoreFaucetOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amt",
        type: "uint256",
      },
    ],
    name: "setMintAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenFaucets",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
